import { render, staticRenderFns } from "./fwlmjj.vue?vue&type=template&id=3964ea24&scoped=true"
import script from "./fwlmjj.vue?vue&type=script&lang=js"
export * from "./fwlmjj.vue?vue&type=script&lang=js"
import style0 from "./fwlmjj.vue?vue&type=style&index=0&id=3964ea24&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964ea24",
  null
  
)

export default component.exports